import { fetchPostLikeList } from '@/api/post/post';
export default {
  data() {
    return {
      id: 0, // post id
      postLikeLoaded: false,
      postLikeData: [],
      postLikePage: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        pageSizes: [10, 20, 50, 100],
        layout: 'total, sizes, prev, pager, next, jumper'
      },
    }
  },
  mounted() {
    this.postLikeLoaded = false;
  },
  methods: {
    initPostLike() {
      if (this.postLikeLoaded) {
        return;
      }

      this.getPostLikeList();
    },
    getPostLikeList() {
      let params = {
        current: this.postLikePage.currentPage,
        size: this.postLikePage.pageSize,
        postId: this.id
      }
      fetchPostLikeList(params).then(response => {
        if (response.data.data != null) {
          this.postLikeData = response.data.data.records;
          this.postLikeData.forEach(like => {
            like.realname = like.memberType===1
              ? like.relatedPersonalRealname
              : like.realname;
          });
          this.postLikePage.total = response.data.data.total;
        } else  {
          this.postLikeData = []
          this.postLikePage.total = 0;
        }
      }).catch(error => {
        this.$message({
          showClose: true,
          message: '获取点赞列表失败',
          type: 'error'
        });
      });
      this.postLikeLoaded = true;
    },
    postLikeCurrentChange(val) {
      this.postLikePage.currentPage = val;
      this.getPostLikeList();
    },
    postLikeSizeChange(val) {
      this.postLikePage.pageSize = val;
      this.getPostLikeList();
    },
  }
}
